import { render, staticRenderFns } from "./EmailGenerator.vue?vue&type=template&id=9894323c&scoped=true"
import script from "./EmailGenerator.vue?vue&type=script&lang=js"
export * from "./EmailGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9894323c",
  null
  
)

export default component.exports